import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import AppShell from "../components/AppShell";
import { FUNDER_NAV } from "./FunderTerminal";
import { Star, TrendingUp } from "lucide-react";

export default function FunderSaved() {
  const nav = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/funder/saved");
      setRows(data);
    } catch (err) {
      if (process.env.NODE_ENV === "development") console.warn("[FunderSaved] load failed", err);
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => { load(); }, [load]);
  const unsave = async (id, e) => {
    e.stopPropagation();
    await api.delete(`/funder/sme/${id}/save`);
    setRows(r => r.filter(x => x.company_id !== id));
  };
  return (
    <AppShell nav={FUNDER_NAV}>
      <h1 className="text-3xl font-bold text-neutral-900">Saved deals</h1>
      <p className="mt-1 text-sm text-neutral-600">Your watchlist of high-conviction opportunities.</p>
      <div className="mt-6 overflow-hidden rounded-2xl border border-neutral-200 bg-white" data-testid="saved-table">
        {loading ? <p className="p-8 text-center text-sm text-neutral-500">Loading…</p> :
          rows.length === 0 ? <p className="p-12 text-center text-sm text-neutral-500">No saved deals yet. Tap the star on any deal in the Terminal.</p> :
          rows.map(d => (
            <button key={d.company_id} onClick={()=>nav(`/funder/sme/${d.company_id}`)}
              data-testid={`saved-${d.company_id}`}
              className="grid w-full grid-cols-12 items-center gap-2 border-t border-neutral-100 px-5 py-4 text-left text-sm transition-colors first:border-t-0 hover:bg-[#F4F8F8]">
              <div className="col-span-4">
                <p className="font-semibold text-neutral-900">{d.company_name}</p>
                <p className="text-xs text-neutral-500 line-clamp-1">{d.value_prop}</p>
              </div>
              <div className="col-span-2 text-neutral-600">{d.country}</div>
              <div className="col-span-2 text-neutral-600">{d.sector}</div>
              <div className="col-span-2 text-neutral-600">${((d.ticket_min||0)/1000).toFixed(0)}K–${((d.ticket_max||0)/1000).toFixed(0)}K</div>
              <div className="col-span-1 flex items-center justify-end gap-2">
                <span className="rounded-md bg-neutral-100 px-1.5 py-0.5 text-[10px] font-bold text-neutral-600" title="Readiness">R {d.readiness_score||0}</span>
                <div className="flex items-center gap-1 text-[#0A8B85]"><TrendingUp className="h-3.5 w-3.5"/><span className="font-extrabold">{d.compatibility ?? 0}</span></div>
              </div>
              <div className="col-span-1 text-right">
                <button data-testid={`unsave-${d.company_id}`} onClick={(e)=>unsave(d.company_id, e)} className="rounded-md p-1 text-[#0A8B85] hover:bg-[#0A8B85]/10">
                  <Star className="h-4 w-4 fill-current"/>
                </button>
              </div>
            </button>
          ))}
      </div>
    </AppShell>
  );
}
